const youtubeRegex =
  // eslint-disable-next-line no-useless-escape
  /^(?:(?:https|http):\/\/)?(?:www\.)?(?:youtube\.com|youtu\.be).*(?<=\/|v\/|u\/|embed\/|shorts\/|watch\?v=)(?<id>[\w\-]{11,15})(\S+)?$/

const youtubeParser = url => {
  const match = url.match(youtubeRegex)
  return match?.groups?.id || null
}

const regexSKU = /^[a-zA-Z0-9_.-]+$/

export { youtubeParser, youtubeRegex, regexSKU }
